/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CarrierStatus {
    DoNotUse = 100,
    Active = 120,
    Inactive = 130,
}
